/* global G */
import { curry, PlatformEvent } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { get } from 'lib/sequence/component/state/value'
import back from 'app/_shared/events/redirect/back'
import sequenceComponentState from 'lib/sequence/component/state'

const {
  set: setError,
  clear: clearError,
} = sequenceComponentState('error')

const {
  set: setHelperText,
  clear: clearHelperText,
} = sequenceComponentState('helperText')

const invalidCodeErrorText = (module: Gaia.AppModule.Spec) => {
  const intl = module[G.ADAPTER][G.INTL]
  return intl._t('validator.generic.invalidFormat', {
      ns: 'common',
      _key: 'validator.generic.invalidFormat',
      defaultValue: 'Invalid {{label}} format',
      label: '$t(apmGo:label.licenceCode)'
    },
  )
}

const emptyCodeErrorText = (module: Gaia.AppModule.Spec) => {
  const intl = module[G.ADAPTER][G.INTL]
  return intl._t('validator.generic.notEmpty', {
      ns: 'common',
      _key: 'validator.generic.notEmpty',
      defaultValue: '{{label}} is required',
      label: '$t(apmGo:label.licenceCode)'
    },
  )
}

const displayFieldFeedback = async (
  module: Gaia.AppModule.Spec,
  field: Gaia.Component.Spec,
  errorText?: string,
) => {
  if (!errorText) {
    clearError(field)
    clearHelperText(field)
  } else {
    setError(field)
    setHelperText(field, errorText)
  }
  await module[G.ADAPTER][G.UI].update(module)
}

/**
 * Initializes the update license flow by going back to the
 * 'sensorDetail' action with the field's code as an argument.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const updateLicence = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const { code: codeField } = find(module[G.STATE][G.ACTION][G.COMPONENT])
  await displayFieldFeedback(module, codeField)

  const codeString = get(codeField)

  if (!codeString) {
    await displayFieldFeedback(module, codeField, emptyCodeErrorText(module))
  } else {
    try {
      const code = JSON.parse(codeString)
      await back(module, component, new PlatformEvent(event, { code }))
    } catch (e) {
      await displayFieldFeedback(module, codeField, invalidCodeErrorText(module))
      console.warn(`Invalid code: ${codeString}`)
    }
  }
}

export default curry(updateLicence)
